import { Timestamp } from '@angular/fire/firestore';
import { createAction, props } from '@ngrx/store';
import { Album } from '../../models/album.model';
import { AppExceptionModel } from '../../models/app-exception.model';

export const getAlbums = createAction(
  '[Album] Get Albums',
  props<{ groupId: string; lastAlbumDate?: Timestamp; limit?: number }>(),
);

export const getAlbum = createAction(
  '[Album] Get Album',
  props<{ groupId: string; albumId: string }>(),
);

export const getAlbumsFailure = createAction(
  '[Album] Get Albums failure',
  props<{ error: AppExceptionModel }>(),
);

export const addOneToStore = createAction(
  '[Album] Add to store',
  props<{ album: Album }>(),
);
export const addManyToStore = createAction(
  '[Album] Add Many to store',
  props<{ albums: Album[] }>(),
);
export const createAlbum = createAction(
  '[Album] Create',
  props<{ album: Partial<Album> }>(),
);
export const createFailure = createAction(
  '[Album] Create failure',
  props<{ error: any }>(),
);
export const createSuccess = createAction(
  '[Album] Create success',
  props<{ album: Album }>(),
);

export const updateAlbum = createAction(
  '[Album] Update',
  props<{ id: string; album: Partial<Album> }>(),
);
export const updateFailure = createAction(
  '[Album] Update failure',
  props<{ error: AppExceptionModel }>(),
);
export const updateSuccess = createAction(
  '[Album] Update success',
  props<{ album: Album }>(),
);

export const deleteAlbum = createAction(
  '[Album] Delete',
  props<{ id: string }>(),
);
export const deleteFailure = createAction(
  '[Album] Delete failure',
  props<{ error: AppExceptionModel }>(),
);
export const deleteSuccess = createAction(
  '[Album] Delete success',
  props<{ id: string }>(),
);

export const clearFromStore = createAction(
  '[Album] Clear from store',
  props<{ ids: string[] }>(),
);

export const clear = createAction('[Album] Clear Albums');
